import i18n from "../../services/localization-service/i18n";
import { BaseActionEnum } from "../../components/action-menu/ActionMenuItem";
import { getActionMenuItems } from "../../components/action-menu/BaseActions";

export const MAX_FILE_SIZE_BYTES = 1024 * 1024 * 1000;


const actionEnums = [
     BaseActionEnum.CreateNew,
     BaseActionEnum.Refresh,
];

export const actions = getActionMenuItems(actionEnums);

export const actionItems = actions.map(o => {

    if (o.action === BaseActionEnum.CreateNew) {
        o.label = i18n.t("actions.newDataFileImport");
    }

    return o;
});
